import React, { useEffect } from 'react';
import { MapContainer, TileLayer, CircleMarker, Tooltip, useMap } from 'react-leaflet';
import type { ServiceArea } from '../data/content';
interface ServiceAreaMapProps {
  areas: ServiceArea[];
  selected: ServiceArea;
  onSelect: (area: ServiceArea) => void;
}
function FlyToSelected({
  selected
}: {
  selected: ServiceArea;
}) {
  const map = useMap();
  useEffect(() => {
    map.flyTo([selected.lat, selected.lng], 11, {
      duration: 0.6
    });
  }, [map, selected]);
  return null;
}
export function ServiceAreaMap({
  areas,
  selected,
  onSelect
}: ServiceAreaMapProps) {
  return <div className="h-[380px] w-full overflow-hidden rounded-lg border border-forest-100 lg:h-[460px]" data-id="element-329" data-mp="4j3uh573m5zh">
      <MapContainer center={[33.13, -117.25]} zoom={10} scrollWheelZoom={false} className="h-full w-full" data-id="element-330" data-mp="3vq6gzjbzro3d">
        <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>' data-id="element-331" data-mp="1ywlhmr3ld0tz" />

        {areas.map(area => {
        const isSelected = area.name === selected.name;
        return <CircleMarker key={area.name} center={[area.lat, area.lng]} radius={isSelected ? 15 : 9} pathOptions={{
          color: isSelected ? '#171a16' : '#3f7522',
          weight: isSelected ? 3 : 2,
          fillColor: isSelected ? '#66a83c' : '#7bbf55',
          fillOpacity: isSelected ? 0.95 : 0.55
        }} eventHandlers={{
          click: () => onSelect(area)
        }} data-id="element-332" data-mp="1s3h2zay6jk56">
              <Tooltip direction="top" offset={[0, -6]} opacity={1} data-id="element-333" data-mp="2fzcua7owtqxz">
                <span className="text-xs font-semibold uppercase tracking-wide" data-id="element-334" data-mp="33pyz7q3mav3r">{area.name}</span>
              </Tooltip>
            </CircleMarker>;
      })}

        <FlyToSelected selected={selected} data-id="element-335" data-mp="38hqj5hs9q2kx" />
      </MapContainer>
    </div>;
}